import { render } from "./iptv-glue.vue?vue&type=template&id=753b6128"
import script from "./iptv-glue.vue?vue&type=script&lang=js"
export * from "./iptv-glue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__